module.exports = __webpack_public_path__ + "assets/img/star_sentence_un9.042045db.png";